import { useLocation } from "wouter";

const C = {
  bg: "#0a0a0a",
  text: "#f5f5f5",
  muted: "#888888",
  bordeaux: "#6d0000",
  border: "#222222",
  card: "#141414",
};

const LOGO_URL = "/manus-storage/logo_2d439bd1.jpg";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div style={{ minHeight: "100vh", backgroundColor: C.bg, color: C.text, fontFamily: "'DM Sans', sans-serif" }}>
      {/* Bordeaux-Akzentlinie */}
      <div style={{ height: "4px", backgroundColor: C.bordeaux }} />

      {/* Header */}
      <header style={{ padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: `1px solid ${C.border}`, backgroundColor: C.bg }}>
        <a href="/" style={{ display: "flex", alignItems: "center", gap: "12px", textDecoration: "none" }}>
          <img src={LOGO_URL} alt="WERBEAGENTUR Larissa Girenko" style={{ width: "40px", height: "40px", objectFit: "contain" }} />
          <div>
            <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontWeight: 700, fontSize: "14px", letterSpacing: "0.1em", textTransform: "uppercase" as const, color: C.text }}>
              WERBEAGENTUR Larissa Girenko
            </span>
          </div>
        </a>
        <a href="/" style={{ color: C.muted, fontSize: "13px", textDecoration: "none" }}>← Zurück zur Startseite</a>
      </header>

      {/* Inhalt */}
      <main style={{ maxWidth: "700px", margin: "0 auto", padding: "80px 24px", textAlign: "center" as const }}>
        {/* 404 Headline */}
        <p style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(6rem, 20vw, 12rem)", lineHeight: 1, color: C.bordeaux, margin: "0 0 8px" }}>
          404
        </p>

        <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(1.6rem, 4vw, 2.4rem)", letterSpacing: "0.05em", color: C.text, margin: "0 0 16px", textTransform: "uppercase" as const }}>
          Seite nicht gefunden
        </h1>

        <p style={{ color: C.muted, fontSize: "15px", lineHeight: 1.7, maxWidth: "480px", margin: "0 auto 40px" }}>
          Die gesuchte Seite existiert nicht oder wurde verschoben. Kein Problem – hier findest du schnell, was du suchst.
        </p>

        {/* CTAs */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", marginBottom: "56px" }}>
          <button
            onClick={() => setLocation("/")}
            style={{ backgroundColor: C.bordeaux, color: "#fff", border: "none", padding: "14px 28px", cursor: "pointer", fontFamily: "'Bebas Neue', sans-serif", fontSize: "16px", letterSpacing: "0.1em", textTransform: "uppercase" as const }}
          >
            Zur Startseite →
          </button>
          <button
            onClick={() => setLocation("/google-ads")}
            style={{ backgroundColor: "transparent", color: C.text, border: `1px solid ${C.border}`, padding: "14px 28px", cursor: "pointer", fontFamily: "'Bebas Neue', sans-serif", fontSize: "16px", letterSpacing: "0.1em", textTransform: "uppercase" as const }}
          >
            Google Ads
          </button>
          <button
            onClick={() => setLocation("/website-realitaetscheck")}
            style={{ backgroundColor: "transparent", color: C.text, border: `1px solid ${C.border}`, padding: "14px 28px", cursor: "pointer", fontFamily: "'Bebas Neue', sans-serif", fontSize: "16px", letterSpacing: "0.1em", textTransform: "uppercase" as const }}
          >
            Website-Analyse
          </button>
        </div>

        {/* Trennlinie */}
        <div style={{ height: "1px", backgroundColor: C.border, margin: "0 auto 40px", maxWidth: "400px" }} />

        {/* Beliebte Seiten */}
        <p style={{ color: C.muted, fontSize: "12px", letterSpacing: "0.12em", textTransform: "uppercase" as const, marginBottom: "20px", fontFamily: "'DM Sans', sans-serif" }}>
          Beliebte Seiten
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center" }}>
          {[
            { label: "Sensorik-Barometer", href: "/sensorik" },
            { label: "SEO-Barometer", href: "/seo-barometer" },
            { label: "Lokal-Barometer", href: "/lokal" },
            { label: "Datenschutz-Barometer", href: "/datenschutz-barometer" },
            { label: "Kontakt", href: "/kontakt" },
          ].map((link) => (
            <a
              key={link.href}
              href={link.href}
              style={{ color: C.bordeaux, fontSize: "13px", textDecoration: "none", padding: "6px 14px", border: `1px solid ${C.bordeaux}22`, fontFamily: "'DM Sans', sans-serif" }}
            >
              {link.label}
            </a>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer style={{ borderTop: `1px solid ${C.border}`, padding: "20px 24px", textAlign: "center" as const }}>
        <p style={{ color: C.muted, fontSize: "12px", margin: 0 }}>
          <a href="/impressum" style={{ color: C.muted, marginRight: "16px", textDecoration: "none" }}>Impressum</a>
          <a href="/datenschutz" style={{ color: C.muted, textDecoration: "none" }}>Datenschutz</a>
        </p>
      </footer>
    </div>
  );
}
